export const SHELTER = 'shelter';